<h1 mat-dialog-title class="dialog-title-row">
	<span i18n>Required Versions <small class="align-top">- {{dialogData.appKey.name}}</small></span>
	<button
		mat-icon-button
		type="button"
		(click)="openCreatePlatformDialog()"
		matTooltip="Add new platform"
		i18n-matTooltip
		title="Add new platform"
		i18n-title
		class="add-platform-btn"
	>
		<mat-icon>add_circle_outline</mat-icon>
	</button>
</h1>

<div mat-dialog-content class="main-content">
	<app-loader-wrapper [loading]="loading" size="sm">
		<div *ngIf="!loading">
			<div class="alert alert-light mb-2" *ngIf="platforms.length === 0" i18n>
				No required versions configured for this app key.
			</div>

			<mat-expansion-panel class="mb-2" *ngFor="let platform of platforms" [expanded]="true">
				<mat-expansion-panel-header>
					<mat-panel-title>{{platform}}</mat-panel-title>
					<span class="spacer"></span>
					<button
						mat-icon-button
						(click)="onCreateNewVersion(platform); $event.stopPropagation()"
						matTooltip="Add new required version"
						i18n-matTooltip
						title="Add new required version"
						i18n-title
						class="add-version-btn"
					>
						<mat-icon>add_circle_outline</mat-icon>
					</button>
				</mat-expansion-panel-header>

				<div class="table-responsive">
					<table mat-table [dataSource]="versions[platform]" class="w-100" aria-label="Required versions">
						<!-- Action Column -->
						<ng-container matColumnDef="action">
							<th mat-header-cell *matHeaderCellDef scope="col" i18n>Action</th>
							<td mat-cell *matCellDef="let row">{{row.action}}</td>
						</ng-container>

						<!-- Version Column -->
						<ng-container matColumnDef="version">
							<th mat-header-cell *matHeaderCellDef scope="col" i18n>Version</th>
							<td mat-cell *matCellDef="let row">{{row.version}}</td>
						</ng-container>

						<!-- Build Column -->
						<ng-container matColumnDef="build">
							<th mat-header-cell *matHeaderCellDef scope="col" i18n>Build</th>
							<td mat-cell *matCellDef="let row">{{row.buildNumber}}</td>
						</ng-container>

						<!-- Min OS Column -->
						<ng-container matColumnDef="minOS">
							<th mat-header-cell *matHeaderCellDef scope="col" i18n>Min OS</th>
							<td mat-cell *matCellDef="let row">{{row.minOSVersion}}</td>
						</ng-container>

						<!-- Released Column -->
						<ng-container matColumnDef="released">
							<th mat-header-cell *matHeaderCellDef scope="col" i18n>Released</th>
							<td mat-cell *matCellDef="let row">{{row.releasedAt | date:'medium'}}</td>
						</ng-container>

						<!-- Actions Column -->
						<ng-container matColumnDef="actions">
							<th mat-header-cell *matHeaderCellDef scope="col" class="text-center"></th>
							<td mat-cell *matCellDef="let row; let i = dataIndex" class="text-center">
								<button
									mat-icon-button
									[matMenuTriggerFor]="actionMenu"
									aria-label="Action menu button"
									title="Available actions"
									i18n-title
									(menuClosed)="openedMenu = null"
									(menuOpened)="openedMenu = i"
									[disabled]="false"
								>
									<mat-icon>more_vert</mat-icon>
								</button>

								<mat-menu #actionMenu="matMenu">
									<button
										mat-menu-item
										i18n
										title="Edit required version."
										i18n-title
										(click)="onEditVersion(platform, row)"
										class="version-action__edit"
									>Edit</button>
									<button
										mat-menu-item
										i18n
										title="Delete required version."
										i18n-title
										(click)="onDeleteVersion(platform, row.action)"
										class="version-action__delete"
									>Delete</button>
								</mat-menu>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="['action', 'version', 'build', 'minOS', 'released', 'actions']"></tr>
						<tr mat-row *matRowDef="let row; columns: ['action', 'version', 'build', 'minOS', 'released', 'actions'];"></tr>
					</table>
				</div>
			</mat-expansion-panel>
		</div>
	</app-loader-wrapper>
</div>

<div mat-dialog-actions class="row px-1 mb-0 justify-content-center">
	<div class="col-6 text-center">
		<button class="w-100" type="button" (click)="close()" mat-flat-button i18n>Close</button>
	</div>
</div>

